"use strict";

var _slicedToArray = require("/var/lib/jenkins/workspace/Static-Websites/Production/prod-minha.glambox.react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/var/lib/jenkins/workspace/Static-Websites/Production/prod-minha.glambox.react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _toConsumableArray = require("/var/lib/jenkins/workspace/Static-Websites/Production/prod-minha.glambox.react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeTypeDuplicates;
var _generated = require("../../validators/generated");
function getQualifiedName(node) {
  return (0, _generated.isIdentifier)(node) ? node.name : "".concat(node.right.name, ".").concat(getQualifiedName(node.left));
}
function removeTypeDuplicates(nodes) {
  var generics = new Map();
  var bases = new Map();
  var typeGroups = new Set();
  var types = [];
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    if (!node) continue;
    if (types.indexOf(node) >= 0) {
      continue;
    }
    if ((0, _generated.isTSAnyKeyword)(node)) {
      return [node];
    }
    if ((0, _generated.isTSBaseType)(node)) {
      bases.set(node.type, node);
      continue;
    }
    if ((0, _generated.isTSUnionType)(node)) {
      if (!typeGroups.has(node.types)) {
        nodes.push.apply(nodes, _toConsumableArray(node.types));
        typeGroups.add(node.types);
      }
      continue;
    }
    if ((0, _generated.isTSTypeReference)(node) && node.typeParameters) {
      var name = getQualifiedName(node.typeName);
      if (generics.has(name)) {
        var existing = generics.get(name);
        if (existing.typeParameters) {
          if (node.typeParameters) {
            existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
          }
        } else {
          existing = node.typeParameters;
        }
      } else {
        generics.set(name, node);
      }
      continue;
    }
    types.push(node);
  }
  var _iterator = _createForOfIteratorHelper(bases),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        baseType = _step$value[1];
      types.push(baseType);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(generics),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        genericName = _step2$value[1];
      types.push(genericName);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return types;
}